export const SHIPMENTS_PREFIX = 'shipments.'
export const SHIPMENTS_TAB_PREFIX = 'shipmentsTab.'
export const PURCHASE_ORDER_PREFIX = 'purchaseOrder.'
export const PURCHASE_ORDER_SHIPMENTS_TAB_PREFIX = 'purchaseOrder.shipmentsTab.'
export const SHIPMENT_DOMAIN_PREFIX = 'shipment.'
